
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/an-invitation-to-try-shipvista-com-for-free",
      function () {
        return require("private-next-pages/an-invitation-to-try-shipvista-com-for-free.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/an-invitation-to-try-shipvista-com-for-free"])
      });
    }
  